import { render, staticRenderFns } from "./SkillTable.vue?vue&type=template&id=e3d412e4&scoped=true"
import script from "./SkillTable.vue?vue&type=script&lang=js"
export * from "./SkillTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d412e4",
  null
  
)

export default component.exports